module.exports = __webpack_public_path__ + "img/gongshang.a4f75eb7.png";